<template>
  <transition name="fade">
    <div id="modal-backdrop-wrap" :class="(uiStore.darkMode ? 'dark-mode' : 'light-mode')">
      <div v-if="uiStore.modalType !== ModalTypes.INACTIVE" @click="clickOnBackDrop" id="modal-backdrop">
        <div id="modal-outer-wrap" :class="(uiStore.darkMode ? 'dark-mode' : 'light-mode')">        
          <div id="modal-window">
              <ModalHeader 
                @close="changeModalType(ModalTypes.INACTIVE)" 
                :headerTitle="currentHeader"
              ></ModalHeader>
              <div class="modal-content">
                <component :is="currentComponent"/>
              </div>          
            <ModalFooter/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { useUIStore } from '@/store/uiStore';
import { ModalTypes } from '@/types/enums';
import { computed, watch } from 'vue';

const uiStore = useUIStore();

watch(() => uiStore.modalType, newVal => {
  console.log("ModalWindow.vue: uiStore.modalType changed to: " + newVal);
});

const changeModalType = (new_type) => {
  uiStore.setModalType(new_type);
};

const clickOnBackDrop = (event) => {
  if (event.target.id === "modal-backdrop")
    changeModalType(ModalTypes.INACTIVE);
};

const currentComponentData = computed(() => {
  switch (uiStore.modalType) {
    case ModalTypes.DOWNLOAD: return { component: 'ModalDownload', name: 'Download' };
    case ModalTypes.FORGOT: return { component: 'ModalForgot', name: 'Forgot Password' };
    case ModalTypes.LOGIN: return { component: 'ModalLogin', name: 'Sign In / Sign Up' };
    case ModalTypes.NEWSLETTER: return { component: 'ModalNewsletter', name: 'Newsletter Signup' };
    case ModalTypes.PASSWORD: return { component: 'ModalPassword', name: 'Change Password' };
    case ModalTypes.PROFILE: return { component: 'ModalProfile', name: 'User Settings' };
    case ModalTypes.RATE: return { component: 'ModalRate', name: 'Rate Product' };
    case ModalTypes.TIMEOUT: return { component: 'ModalTimeout', name: 'Session Timeout' };
    case ModalTypes.PURCHASE: return { component: 'ModalPurchase', name: 'Thank You For Purchasing' };
    case ModalTypes.REDEEM: return { component: 'ModalRedeem', name: 'Redeem' };
    case ModalTypes.CONTACT: return { component: 'ModalContact', name: 'Contact' };
    case ModalTypes.DELETE: return { component: 'ModalDelete', name: 'Delete Account' };
    case ModalTypes.CHANGE: return { component: 'ModalChange', name: 'Change Account Email' };
    default: return { component: null, name: 'Unknown' };
  }
});

const currentComponent = computed(() => currentComponentData.value.component);
const currentHeader = computed(() => currentComponentData.value.name);

</script>

<script>
import ModalDownload from '@/components/modal/Download.vue';
import ModalForgot from '@/components/modal/Forgot.vue';
import ModalLogin from '@/components/modal/Login.vue';
import ModalNewsletter from '@/components/modal/Newsletter.vue';
import ModalPassword from '@/components/modal/Password.vue';
import ModalProfile from '@/components/modal/Profile.vue';
import ModalRate from '@/components/modal/Rate.vue';
import ModalTimeout from '~/components/modal/Timeout.vue';
import ModalPurchase from '~/components/modal/Purchase.vue';
import ModalRedeem from '~/components/modal/Redeem.vue';
import ModalContact from '~/components/modal/Contact.vue';
import ModalChange from '~/components/modal/ChangeEmail.vue';
import ModalDelete from '~/components/modal/DeleteAccount.vue';

export default {
  components: {
    ModalDownload,
    ModalForgot,
    ModalLogin,
    ModalNewsletter,
    ModalPassword,
    ModalProfile,
    ModalRate,
    ModalTimeout,
    ModalPurchase,
    ModalRedeem,
    ModalContact,
    ModalChange,
    ModalDelete,
  }
}
</script>

<style lang="scss">
@import '~/assets/constants.scss';

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

#modal-backdrop {
  background: $backdrop-background;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99988;

  .modal-nav {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    /*flex-direction: row-reverse;*/
  }

  .modal-content {
    padding: 2rem 3rem;
    background: $light-mode-background;
    color: $light-mode-color;
    .dark-mode & {
      background: $dark-mode-background;
      color: $dark-mode-color;
    }

  }

  .newsletter-categories {
    display: flex;
    gap: 2em;
    margin-bottom: 3rem;
  }

  #modal-outer-wrap {
    position: fixed;
    display: grid;
    align-content: center;
    justify-content: center;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    //width: 50vw;
    transform: translate(-50%, -50%);
    z-index: 99989;
    border-radius: $fa-border-radius;

    @include respond-to("tablet") {
      width: 75vw;
    }

    @include respond-to("phone") {
      width: 90vw;    
    }

    &.light-mode {
      background: $light-mode-background;
      color: $light-mode-color;
    }

    .dark-mode & {
      color: $dark-mode-color;
      background: $dark-mode-background;
    }
  }

  .fa-btn-modal {
    font-size: 1.5rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: min-content;
    height: min-content;
    display: block;

    &:disabled {
      background: gray;
      color: lightgray;
    }
  }

  .sign-up-checkboxes {
    font-size: 1.125rem;
  }

  .privacy-info {
    margin-top: 0.5rem;
    display: block;
    font-size: 0.8rem;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

</style>

